const config = {
    BASE_URL: "https://saleseco.mindfuturetechsupport.com/logistics"
}

export default config;